import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { IUserContext } from '@/base/models';

export interface UserContextState {
  isTryDemoViewable?: boolean;
}

const initialState: UserContextState = {};

const userContextSlice = createSlice({
  name: 'user-context',
  initialState,
  reducers: {
    setIsTryDemoViewable: (state, action) => {
      state.isTryDemoViewable = action.payload;
    },
  },
});

export const { setIsTryDemoViewable } = userContextSlice.actions;
export const isTryDemoViewableRedux = (state: RootState) => state.userContext.isTryDemoViewable;
export default userContextSlice.reducer;
